import React, { useState } from 'react';
import { Mutation } from '@apollo/client/react/components';
import { Delete, Cancel } from '@material-ui/icons';
import {
  IconButton,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import { DELETE_PAGE } from '../../../queries/page';

interface IDeletePageProps {
  selectedRows: any;
  pages: Array<any>;
  refetchList: any;
}

const DeletePage: React.FC<IDeletePageProps> = ({
  selectedRows,
  pages,
  refetchList,
}) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [multiple, setMultiple] = useState(false);

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };

  return (
    <Mutation
      mutation={DELETE_PAGE}
      update={async () => {
        await refetchList();
      }}
    >
      {(deletePage: any) => (
        <div>
          <IconButton
            aria-label="delete"
            onClick={(e) => {
              e.preventDefault();
              if (selectedRows.data.length > 1) {
                setMultiple(true);
              } else {
                setMultiple(false);
              }
              setOpenConfirmation(true);
            }}
          >
            <Delete />
          </IconButton>
          <Dialog
            open={openConfirmation}
            onClose={handleCloseConfirmation}
            aria-labelledby="alert-dialog-product"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-product">Are you sure?</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {multiple
                  ? 'Do you really want to delete these Pages? This process cannot be undone.'
                  : 'Do you really want to delete this Page? This process cannot be undone.'}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseConfirmation} color="default">
                <Cancel />
                {' '}
                Cancel
              </Button>
              <Button
                onClick={() => {
                  selectedRows.data.forEach(async (page: any) => {
                    await deletePage({
                      variables: { id: pages[page.dataIndex].id },
                    });
                    setOpenConfirmation(false);
                  });
                }}
                color="secondary"
                autoFocus
              >
                <Delete />
                {' '}
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </Mutation>
  );
};

export default DeletePage;
